module.exports = __webpack_public_path__ + "files/vergnes.8b55aa2435d4579a03f70115c1561014.pdf";